import { configureStore } from "@reduxjs/toolkit";
import reducers from "./slices";
import storage from "redux-persist/lib/storage";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";
import { thunk } from "redux-thunk";
import logger from "redux-logger";
import createMigrate from "redux-persist/es/createMigrate";
import StorageKeys from "../constants/storage";

const migrations = {
  3: (state) => ({}),
};

const persistConfig = {
  key: StorageKeys.redux,
  storage,
  version: 3,
  migrate: createMigrate(migrations, { debug: false }),
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const reduxStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(thunk)
      .concat(process.env.NODE_ENV === "development" ? logger : []),
});

export const reduxPersistor = persistStore(reduxStore);
export default reduxStore;
